export function arrivalPercentiles(rows) {
  const total = rows[rows.length - 1]?.cumulativeArrived || 0;
  if (!total) return [];
  return Array.from({ length: 11 }, (_, index) => {
    const target = (total * index) / 10;
    const currentIndex = rows.findIndex((row) => row.cumulativeArrived >= target);
    const current = rows[currentIndex];
    const previous = rows[Math.max(0, currentIndex - 1)];
    const range = current.cumulativeArrived - previous.cumulativeArrived;
    const fraction = currentIndex > 0 && range > 0 ? (target - previous.cumulativeArrived) / range : 0;
    return { percentile: index * 10, time: previous.time + (current.time - previous.time) * fraction };
  });
}

export function agentsOnSelectedLinks(rows, selectedIds) {
  const selected = new Set(selectedIds.map(String));
  return rows.filter((row) => selected.has(String(row.link_id)) && row.agent_id !== "");
}
